import { FunctionComponent, PropsWithChildren } from 'react';

interface SecondaryMenuContentProps extends PropsWithChildren {}

const SecondaryMenuContent: FunctionComponent<SecondaryMenuContentProps> = ({ children }) => {
  return <div className="flex  flex-1 shrink flex-col gap-y-4 overflow-y-auto px-4 pb-4 pt-2">{children}</div>;
};

export default SecondaryMenuContent;
